module.exports = __webpack_public_path__ + "static/media/envelope.e586ddde.svg";